import { useNavigate } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import ToolCards from './components/ToolCards';
import SubjectGuideSection from './components/SubjectGuideSection';
import HowItWorks from './components/HowItWorks';
import StatsSection from './components/StatsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <HeroSection />
      <ToolCards />
      <SubjectGuideSection />
      <HowItWorks />
      <StatsSection />
      <Footer />
    </div>
  );
}